import { FC, useEffect, useState } from "react";
import { getMerchants, MerchantType } from "../../api/merchants";
import {
  attachProductToMerchant,
  ProductListItem,
  StockLevel,
} from "../../api/products";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";

interface props {
  isOpen: boolean;
  product: ProductListItem;
  closeModal: () => void;
}

const ConnectedMerchantModal: FC<props> = ({ isOpen, product, closeModal }) => {
  const [merchants, setMerchants] = useState<MerchantType[]>();
  const [connectedProducts, setConnectedProducts] = useState<StockLevel[]>(
    product.stockLevels || []
  );

  useEffect(() => {
    const fetchMerchants = async () => {
      const response = await getMerchants();
      setMerchants(response);
    };
    fetchMerchants();
  }, [product.stockLevels]);

  const attachProduct = async (merchantId: number) => {
    await attachProductToMerchant(product.variantId, merchantId);
    setConnectedProducts([
      ...connectedProducts,
      {
        merchantId,
        id: 0,
        variantId: Number(product.variantId),
        price: product.price,
        amount: product.amount,
        targetAmount: 0,
        triggerAmount: 0,
        targetRelation: 0,
        isActive: true,
      },
    ]);
  };
  return (
    <Dialog
      header={`Anbieter für ${product.title}`}
      visible={isOpen}
      style={{ width: "50vw" }}
      onHide={closeModal}
    >
      {merchants?.map((merchant) => {
        const connectedProduct = connectedProducts.find(
          ({ merchantId }) => merchant.id === merchantId
        );
        return (
          <div
            key={merchant.id}
            className="grid grid-cols-5 gap-4 hover:bg-customgray py-1 border-t border-customgray"
          >
            <span className="col-span-3 font-bold">{merchant.name}</span>
            <span className="col-span-1">
              {connectedProduct ? (
                "Verbunden"
              ) : (
                <Button
                  label={"Product erstellen"}
                  onClick={() => attachProduct(merchant.id || 0)}
                />
              )}
            </span>
            <span className="col-span-1"></span>
          </div>
        );
      })}
    </Dialog>
  );
};

export default ConnectedMerchantModal;
